/**
 * Validation Schema for Update Study Dialog
 *
 * Migrated from: lego/page/etmf/overview/update-study/Validation.jsx
 */

import * as yup from 'yup'

export const ValidationSchema = (currentStep: number) => {
  yup.setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  })

  const val = yup.object().shape({
    product: currentStep < 3 ? yup.number().nullable() : yup.number().nullable().required(),
    study: currentStep < 3 ? yup.number().nullable() : yup.number().nullable().required(),
    environment: currentStep < 3 ? yup.number().nullable() : yup.number().nullable().required(),
    countries: yup.lazy((_value: any, context: any) => {
      if (currentStep < 3) return yup.array().nullable()
      // Only validate countries if level is 'countries'
      if (context.parent.level === 'countries') {
        return yup.array().min(1, 'ETMF_MSG_ERROR_PLEASE_SELECT_ONE_COUNTRY')
      }
      return yup.array().nullable()
    }),
    sites: yup.lazy((_value: any, context: any) => {
      if (currentStep < 3) return yup.array().nullable()
      // Only validate sites if level is 'sites'
      if (context.parent.level === 'sites') {
        return yup.array().min(1, 'ETMF_MSG_ERROR_PLEASE_SELECT_ONE_SITE')
      }
      return yup.array().nullable()
    })
  })

  return val
}
